import React from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  Person as UserIcon,
  Settings as SettingsIcon,
  ShoppingCart as ShoppingIcon,
  Church as ChurchIcon,
  Visibility as VisionIcon,
  Group as GroupIcon,
  CalendarToday as CalendarIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import { Link, Outlet, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";

const drawerWidth = 240;

// 完全透明的侧边栏
const TransparentDrawer = styled(Drawer)(() => ({
  width: drawerWidth,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    boxSizing: "border-box",
    top: "80px",
    height: "calc(100% - 80px)",
    background: "transparent",
    border: "none",
    boxShadow: "none",
  },
}));

// 样式化的列表项
const StyledListItem = styled(ListItem)(({ theme, selected }) => ({
  margin: theme.spacing(0.5, 1),
  borderRadius: theme.spacing(1),
  backgroundColor: selected ? "rgba(255, 255, 255, 0.2)" : "transparent",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
  },
  "& .MuiListItemIcon-root": {
    color: selected ? "rgba(255, 255, 255, 0.95)" : "rgba(255, 255, 255, 0.8)",
  },
  "& .MuiListItemText-primary": {
    color: selected ? "rgba(255, 255, 255, 0.95)" : "rgba(255, 255, 255, 0.8)",
    fontWeight: selected ? 500 : 400,
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
  },
}));

const AdminLayout = () => {
  const location = useLocation();

  // 检查当前路径是否匹配
  const isSelected = (path) => {
    return location.pathname.includes(path);
  };

  return (
    <Box sx={{ display: "flex", mt: 2 }}>
      <TransparentDrawer variant="permanent">
        <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }} />
        <List>
          <StyledListItem
            button
            component={Link}
            to="/administration/home"
            selected={isSelected("/administration/home")}
          >
            <ListItemIcon>
              <UserIcon />
            </ListItemIcon>
            <ListItemText primary="首页事件管理" />
          </StyledListItem>
          <StyledListItem
            button
            component={Link}
            to="/administration/intro"
            selected={isSelected("/administration/intro")}
          >
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="简介内容管理" />
          </StyledListItem>
          <StyledListItem
            button
            component={Link}
            to="/administration/worship"
            selected={isSelected("/administration/worship")}
          >
            <ListItemIcon>
              <ChurchIcon />
            </ListItemIcon>
            <ListItemText primary="崇拜管理" />
          </StyledListItem>
          <StyledListItem
            button
            component={Link}
            to="/administration/vision-space"
            selected={isSelected("/administration/vision-space")}
          >
            <ListItemIcon>
              <VisionIcon />
            </ListItemIcon>
            <ListItemText primary="异象空间管理" />
          </StyledListItem>
          <StyledListItem
            button
            component={Link}
            to="/administration/ministry-worker"
            selected={isSelected("/administration/ministry-worker")}
          >
            <ListItemIcon>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText primary="事奉同工管理" />
          </StyledListItem>
          {/*
          <StyledListItem
            button
            component={Link}
            to="/administration/daily-event"
            selected={isSelected("/administration/daily-event")}
          >
            <ListItemIcon>
              <CalendarIcon />
            </ListItemIcon>
            <ListItemText primary="每日事件管理" />
          </StyledListItem>
          */}
        </List>
      </TransparentDrawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          background: "transparent",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;
